<template>
  <v-container
    fill-height
    style='max-width:100%;'
  >
    <v-row style='height:100%;'>
      <v-col style='height:100%;padding:0;'>
        <v-card
          flat
          class='card-style'
        >
          <div
            class='card-style-title'
          >
            Children cycling to school
            <div class='btnCont'>
              <iframe-modal
                :id='id'
                :src='src'
                :width='1700'
                :height='750'
              />
              <v-btn
                depressed
                rounded
                color='#00486b'
                style='color:#fff'
                width='7em'
                :href='mapDatasetUrls'
                target='_blank'
              >Data</v-btn>
            </div>
          </div>
          <v-container class="contentHolder">
            <v-container v-if='overlay'>
              <v-overlay
                :absolute='true'
                :value='overlay'
              >
                <v-progress-circular
                  indeterminate
                  size='64'
                ></v-progress-circular>
              </v-overlay>
            </v-container>
            <v-container
              v-if='!overlay'
              style='margin:10px;max-width:100%;'
            >
              <v-row>
                <v-col cols='12'>
                  <div class='description'>
                    <p>
                      Percentage of children who answered
                      “cycle” when asked the question “How do you normally travel to school?”
                    </p>
                    <p class='source'>
                      <span>
                        Data Source:
                        <a
                          target='_blank'
                          href='https://www.sustrans.org.uk/our-blog/projects/uk-wide/scotland/hands-up-scotland-survey'
                        >Hands Up Scotland Survey, Sustrans</a>
                      </span>
                    </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols='12'>
                  <clusteredChart
                    id='cyclingToSchool'
                    :data='results'
                    :colors='colors'
                    :x-axis='xAxis'
                    :y-axis='yAxis'
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import clusteredChart from '@/components/clusteredChart.vue';
import iframeModal from '@/components/iframeModal.vue';

export default {
  components: {
    clusteredChart,
    iframeModal,
  },
  data() {
    return {
      results: [],
      overlay: true,
      xAxis: { label: 'Year' },
      yAxis: { label: 'Percentage of pupils traveling by bike' },
      value: 0,
      colors: ['#6fbc85', '#d4d0c7', '#fdc300', '#00b0db'],
      id: 'CycleToSchool',
      src: 'CycleToSchool',
    };
  },
  computed: {
    ...mapGetters(['compositeDataset']),
    mapDatasetUrls() {
      let d = null;
      if (this.compositeDataset && this.compositeDataset.cycleToSchoolDataset) {
        d = this.compositeDataset.cycleToSchoolDataset.dataset;
        this.content(this.compositeDataset.cycleToSchoolDataset.apiResource);
      } else {
        console.error('No API Resource: ( cycleToSchoolDataset )');
      }
      return d;
    },
  },
  methods: {
    async content(resource) {
      const params = { datasetGUID: resource };
      const newResults = await this.$store.dispatch('fetchData', params);
      this.results = newResults.data;
      let highest = null;
      this.results.forEach((result, index) => {
        const val = parseFloat(result.Value);
        if (highest === null || val > highest.value) highest = { value: val, index };
      });
      this.results.splice(highest.index, 1);
      this.value = highest.value;
      this.overlay = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-style {
  padding: 2em;
  width: 100%;
  height: 100%;
  justify-content: center;
}
.description {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  p {
    font-size: 1em;
    font-weight: bold;
  }
  .source {
    font-size: 0.8em;
    font-style: italic;
    font-weight: bold;
  }
}
@media (min-width: 650px) {
  .description {
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    p {
      font-size: 1.2em;
      font-weight: bold;
    }
  }
  .contentHolder {
    margin: 10px;
    max-width: 100%;
  }
}
</style>
